import { atom } from "@reatom/framework";

export const SafeAreaInsetTopAtom = atom<number>(0, "SafeAreaInsetTopAtom");
export const SafeContentAreaInsetTopAtom = atom<number>(
  0,
  "SafeContentAreaInsetTopAtom"
);
